@if (showShellHeader()) {
  <h2 class="font-bold mb-4">{{ 'TRANSACTIONS' | transloco }}</h2>

  <div class="mb-4">
    <p-tabs [value]="activeTabIndex()" (valueChange)="onTabChange($event)">
      <p-tablist>
        @for (tab of tabs(); track tab.value) {
          <p-tab [value]="tab.value">{{ tab.title }}</p-tab>
        }
      </p-tablist>
    </p-tabs>
  </div>
}

<router-outlet />
